import type {
  PlaceState,
  Place,
} from '@web-platform/shared-universal-types/src/redux/state/places/places';
import type { EntityId } from '@web-platform/shared-universal-types-utils/src/utils';

export const getByEntityId = (state: PlaceState, entityId: EntityId): Place =>
  state.byEntityId[entityId];

export const allByEntityId = (state: PlaceState): Record<EntityId, Place> => state.byEntityId;
